// // // components/CleanFullDescInfo.js
// // 'use client'
// // import { useEffect } from 'react';

// // const CleanFullDescInfo = () => {
// //     useEffect(() => {
// //         // Получаем все элементы с классом 'full_desc_info'
// //         const fullDescElements = document.querySelectorAll('.full_desc_info');

// //         fullDescElements.forEach(container => {
// //             // 1. Удаление <p> элементов с содержимым только 't'
// //             const pElements = container.querySelectorAll('p');

// //             pElements.forEach(p => {
// //                 const trimmedText = p.textContent.trim();
// //                 if (trimmedText === 't') {
// //                     p.remove();
// //                 } else {
// //                     // Замена iHerb на Vitaline в параграфах
// //                     if (p.textContent.includes('iHerb')) {
// //                         p.textContent = p.textContent.replace(/iHerb/g, 'Vitaline');
// //                     }
// //                 }
// //             });

// //             // 2. Обработка текстовых узлов
// //             const treeWalker = document.createTreeWalker(
// //                 container,
// //                 NodeFilter.SHOW_TEXT,
// //                 {
// //                     acceptNode: function (node) {
// //                         const text = node.textContent.trim();
// //                         if (text === 't') {
// //                             return NodeFilter.FILTER_ACCEPT;
// //                         }
// //                         return NodeFilter.FILTER_SKIP;
// //                     }
// //                 },
// //                 false
// //             );

// //             let currentNode = treeWalker.nextNode();
// //             while (currentNode) {
// //                 const nodeToRemove = currentNode;
// //                 currentNode = treeWalker.nextNode();
// //                 nodeToRemove.parentNode.removeChild(nodeToRemove);
// //             }

// //             // 3. Замена iHerb на Vitaline в оставшихся текстовых узлах
// //             const textWalker = document.createTreeWalker(
// //                 container,
// //                 NodeFilter.SHOW_TEXT,
// //                 null,
// //                 false
// //             );

// //             let textNode = textWalker.nextNode();
// //             while (textNode) {
// //                 if (textNode.textContent.includes('iHerb')) {
// //                     textNode.textContent = textNode.textContent.replace(/iHerb/g, 'Vitaline');
// //                 }
// //                 textNode = textWalker.nextNode();
// //             }
// //         });
// //     }, []); // Пустой массив зависимостей ensures this runs once on mount

// //     return null; // Этот компонент не рендерит ничего
// // };

// // export default CleanFullDescInfo;






// // components/CleanFullDescInfo.js
// 'use client'
// import { useEffect } from 'react';

// const CleanFullDescInfo = () => {
//     useEffect(() => {
//         // Существующий код обработки full_desc_info
//         const fullDescElements = document.querySelectorAll('.full_desc_info');

//         fullDescElements.forEach(container => {
//             const pElements = container.querySelectorAll('p');

//             pElements.forEach(p => {
//                 const trimmedText = p.textContent.trim();
//                 if (trimmedText === 't') {
//                     p.remove();
//                 } else {
//                     if (p.textContent.includes('iHerb')) {
//                         p.textContent = p.textContent.replace(/iHerb/g, 'Vitaline');
//                     }
//                 }
//             });

//             const treeWalker = document.createTreeWalker(
//                 container,
//                 NodeFilter.SHOW_TEXT,
//                 {
//                     acceptNode: function (node) {
//                         const text = node.textContent.trim();
//                         if (text === 't') {
//                             return NodeFilter.FILTER_ACCEPT;
//                         }
//                         return NodeFilter.FILTER_SKIP;
//                     }
//                 },
//                 false
//             );

//             let currentNode = treeWalker.nextNode();
//             while (currentNode) {
//                 const nodeToRemove = currentNode;
//                 currentNode = treeWalker.nextNode();
//                 nodeToRemove.parentNode.removeChild(nodeToRemove);
//             }

//             const textWalker = document.createTreeWalker(
//                 container,
//                 NodeFilter.SHOW_TEXT,
//                 null,
//                 false
//             );

//             let textNode = textWalker.nextNode();
//             while (textNode) {
//                 if (textNode.textContent.includes('iHerb')) {
//                     textNode.textContent = textNode.textContent.replace(/iHerb/g, 'Vitaline');
//                 }
//                 textNode = textWalker.nextNode();
//             }
//         });

//         // Обновленный код для копирования с двойным кликом и анимацией
//         const copyButton = document.querySelector('#copy_target_full_meta');
//         if (copyButton) {
//             let clickCount = 0;
//             let clickTimer = null;

//             copyButton.addEventListener('click', () => {
//                 clickCount++;

//                 if (clickCount === 1) {
//                     clickTimer = setTimeout(() => {
//                         clickCount = 0;
//                     }, 2000); // 2 секунды на второй клик
//                 }

//                 if (clickCount === 2) {
//                     clearTimeout(clickTimer);
//                     clickCount = 0;

//                     const catAndTag = document.querySelector('.cat_and_tag');
//                     if (!catAndTag) return;

//                     const tagsList = catAndTag.querySelector('.categories_list:first-child .list');
//                     const tags = tagsList
//                         ? Array.from(tagsList.querySelectorAll('a'))
//                             .map(a => `\`${a.textContent.trim()}\``)
//                             .join('\n')
//                         : '';

//                     const categoriesList = catAndTag.querySelector('.categories_list:last-child .list');
//                     const categories = categoriesList
//                         ? Array.from(categoriesList.querySelectorAll('a'))
//                             .map(a => `\`${a.textContent.trim()}\``)
//                             .join('\n')
//                         : '';

//                     const textToCopy = `Метки:\n${tags}\n---------\nКатегории:\n${categories}`;

//                     // Копирование и анимация
//                     navigator.clipboard.writeText(textToCopy)
//                         .then(() => {
//                             // Добавляем стили для анимации
//                             copyButton.style.transition = 'all 0.3s ease';
//                             copyButton.style.padding = '0 10px';
//                             copyButton.style.borderRadius = '5px';
//                             copyButton.style.background = '#f1f1f1';

//                             // Через 0.5 секунды возвращаем исходные стили
//                             setTimeout(() => {
//                                 copyButton.style.padding = '0';
//                                 copyButton.style.borderRadius = '0';
//                                 copyButton.style.background = '#ffffff';
//                             }, 500);
//                         })
//                         .catch(err => {
//                             console.error('Ошибка при копировании: ', err);
//                         });
//                 }
//             });
//         }

//         // Cleanup
//         return () => {
//             if (copyButton) {
//                 copyButton.removeEventListener('click', () => { });
//             }
//         };
//     }, []);

//     return null;
// };

// export default CleanFullDescInfo;


// components/CleanFullDescInfo.js
'use client'
import { useEffect } from 'react';

const CleanFullDescInfo = () => {
    useEffect(() => {
        // Существующий код обработки full_desc_info
        const fullDescElements = document.querySelectorAll('.full_desc_info');

        fullDescElements.forEach(container => {
            const pElements = container.querySelectorAll('p');

            pElements.forEach(p => {
                const trimmedText = p.textContent.trim();
                if (trimmedText === 't') {
                    p.remove();
                } else {
                    if (p.textContent.includes('iHerb')) {
                        p.textContent = p.textContent.replace(/iHerb/g, 'Vitaline');
                    }
                }
            });

            const treeWalker = document.createTreeWalker(
                container,
                NodeFilter.SHOW_TEXT,
                {
                    acceptNode: function (node) {
                        const text = node.textContent.trim();
                        if (text === 't') {
                            return NodeFilter.FILTER_ACCEPT;
                        }
                        return NodeFilter.FILTER_SKIP;
                    }
                },
                false
            );

            let currentNode = treeWalker.nextNode();
            while (currentNode) {
                const nodeToRemove = currentNode;
                currentNode = treeWalker.nextNode();
                nodeToRemove.parentNode.removeChild(nodeToRemove);
            }

            const textWalker = document.createTreeWalker(
                container,
                NodeFilter.SHOW_TEXT,
                null,
                false
            );

            let textNode = textWalker.nextNode();
            while (textNode) {
                if (textNode.textContent.includes('iHerb')) {
                    textNode.textContent = textNode.textContent.replace(/iHerb/g, 'Vitaline');
                }
                textNode = textWalker.nextNode();
            }
        });

        // Обновленный код для копирования с двойным кликом и анимацией
        const copyButton = document.querySelector('#copy_target_full_meta');
        if (copyButton) {
            let clickCount = 0;
            let clickTimer = null;

            copyButton.addEventListener('click', () => {
                clickCount++;

                if (clickCount === 1) {
                    clickTimer = setTimeout(() => {
                        clickCount = 0;
                    }, 2000); // 2 секунды на второй клик
                }

                if (clickCount === 2) {
                    clearTimeout(clickTimer);
                    clickCount = 0;

                    const catAndTag = document.querySelector('.cat_and_tag');
                    if (!catAndTag) return;

                    const categoriesList = catAndTag.querySelector('.categories_list:last-child .list');
                    const categories = categoriesList
                        ? Array.from(categoriesList.querySelectorAll('a'))
                            .map(a => `\`${a.textContent.trim()}\``)
                            .join('\n')
                        : '';

                    const tagsList = catAndTag.querySelector('.categories_list:first-child .list');
                    const tags = tagsList
                        ? `\`${Array.from(tagsList.querySelectorAll('a'))
                            .map(a => a.textContent.trim())
                            .join('|')}\``
                        : '';

                    const textToCopy = `Категории:\n${categories}\n---------\nМетки:\n${tags}`;

                    // Копирование и анимация
                    navigator.clipboard.writeText(textToCopy)
                        .then(() => {
                            // Добавляем стили для анимации
                            copyButton.style.transition = 'all 0.3s ease';
                            copyButton.style.padding = '0 10px';
                            copyButton.style.borderRadius = '5px';
                            copyButton.style.background = '#f1f1f1';

                            // Через 0.5 секунды возвращаем исходные стили
                            setTimeout(() => {
                                copyButton.style.padding = '0';
                                copyButton.style.borderRadius = '0';
                                copyButton.style.background = '#ffffff';
                            }, 500);
                        })
                        .catch(err => {
                            console.error('Ошибка при копировании: ', err);
                        });
                }
            });
        }

        // Cleanup
        return () => {
            if (copyButton) {
                copyButton.removeEventListener('click', () => { });
            }
        };
    }, []);

    return null;
};

export default CleanFullDescInfo;